<template>
  <div>
    <v-row>
      <v-col>
        <template v-if="selectedModuleShow.value === 'supervision'">
          <req-tool-supervision
            v-if="requestModuleSelectedSubItem.value === 'by_supervisions'"
            :supervisions="supervisionData"
            :date-range="dateRange"
          />
          <req-tool-recommendation
            v-if="requestModuleSelectedSubItem.value === 'by_recommendations'"
            :supervisions="supervisionData"
            :date-range="dateRange"
          />
        </template>

        <req-tool-training
          v-if="selectedModuleShow.value === 'training'"
          :show-type="requestModuleSelectedSubItem.value"
          :laboratories="labsSelected"
          :laboratories-training-info="laboratoriesTrainingInfo"
          :date-range="dateRange"
        />


        <req-tool-equipment
          v-if="selectedModuleShow.value === 'equipment'"
          :laboratories="labsSelected"
          :country="country"
        />

        <req-tool-workload
          v-if="selectedModuleShow.value === 'workload'"
          :workload-data="workloadData"
          :date-range="dateRangeMonth"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <laboratories-select
          :laboratories="laboratories"
          :labs-selected.sync="labsSelected"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <v-card>
          <v-card-title>
            {{ $t('Selected Laboratories') }} {{ labsSelected.length }}
          </v-card-title>

          <v-card-text>
            <v-form v-model="validForm">
              <v-row>
                <v-col md="5">
                  <v-autocomplete
                    v-model="requestModuleSelected"
                    :items="requestModuleItems"
                    :rules="[val => !!val || '']"
                    hide-selected
                    hide-details
                    outlined
                    color="blue-grey lighten-2"
                    :label="$t('Select Request Module')"
                    cache-items
                    clearable
                    item-text="name"
                    return-object
                    @click:clear="selectedModuleShow = ''"
                  />

                  <v-autocomplete
                    v-if="requestModuleSelected && requestModuleSelected.subItems.length"
                    v-model="requestModuleSelectedSubItem"
                    :rules="[val => !!val || '']"
                    class="mt-3"
                    :items="requestModuleSelected.subItems"
                    :auto-select-first="true"
                    hide-details
                    outlined
                    color="blue-grey lighten-2"
                    :label="requestModuleSelected.subItemLabel"
                    item-text="name"
                    return-object
                    @click:clear="selectedModuleShow = ''"
                  />
                  <!--                <v-autocomplete-->
                  <!--                  v-if-->
                  <!--                  v-model="requestModuleSelected"-->
                  <!--                  :items="requestModuleItems"-->
                  <!--                  hide-selected-->
                  <!--                  hide-details-->
                  <!--                  outlined-->
                  <!--                  color="blue-grey lighten-2"-->
                  <!--                  label="Select Request Module"-->
                  <!--                  cache-items-->
                  <!--                  clearable-->
                  <!--                  item-text="name"-->
                  <!--                  item-value="value"-->
                  <!--                  @click:clear="selectedModuleShow = ''"-->
                  <!--                />-->
                </v-col>
                <v-col md="7">
                  <v-menu
                    v-if="requestModuleSelected && requestModuleSelected.dateRange"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeText"
                        :label="$t('Date Range')"
                        prepend-icon="mdi-calendar"
                        readonly
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="dateRange"
                      :max="maxDate"
                      range
                      scrollable
                      :title-date-format="titleDateFormat"
                      @change="onDateRangeChange"
                    />
                  </v-menu>
                  <v-menu
                    v-if="requestModuleSelected && requestModuleSelected.dateRangeMonth"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeTextMonth"
                        :rules="[val => !!val || '']"
                        :label="$t('Date Range')"
                        prepend-icon="mdi-calendar"
                        readonly
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="dateRangeMonth"
                      :max="maxDate"
                      type="month"
                      range
                      scrollable
                      :title-date-format="titleDateFormat"
                      @change="onDateRangeMonthChange"
                    />
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    color="secondary"
                    :disabled="!(labsSelected.length && validForm)"
                    @click="onRequestModule"
                  >
                    Request
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
    import Me from "@/mixins/Me";
    import Country from "@/mixins/Country";
    import Laboratory from "@/mixins/laboratory/Laboratory";
    import {mapActions} from 'vuex'

    import LaboratoriesSelect from "@/components/administration/LaboratoriesSelect";
    import ReqToolSupervision from "@/components/administration/ReqToolSupervision";
    import ReqToolRecommendation from "@/components/administration/ReqToolRecommendation";
    import ReqToolEquipment from "@/components/administration/ReqToolEquipment";
    import ReqToolWorkload from "@/components/administration/ReqToolWorkload";
    import ReqToolTraining from "@/components/administration/ReqToolTraining";

    export default {
        name: "ReqTool",

        components: {
            LaboratoriesSelect,
            ReqToolSupervision,
            ReqToolRecommendation,
            ReqToolEquipment,
            ReqToolWorkload,
            ReqToolTraining
        },

        mixins: [
            Me,
            Country,
            Laboratory
        ],

        data: () => {
            return {
                validForm: false,
                labsSelected: [],
                supervisionData: [],
                workloadData: [],
                requestModuleSelected: '',
                requestModuleSelectedSubItem: '',
                selectedModuleShow: '',
                dateRange: [],
                dateRangeMonth: []
            }
        },


        computed: {
            requestModuleItems() {
              return [
                  {
                      name: this.$t('Training Management'),
                      value: 'training',
                      dateRange: true,
                      subItemLabel: 'Select',
                      subItems: [
                          {
                              name: this.$t('By Users'),
                              value: 'by_users',

                          },
                          {
                              name: this.$t('By Modules'),
                              value: 'by_modules',

                          }
                      ]
                  },
                  {
                      name: this.$t('Supervision Management'),
                      value: 'supervision',
                      subItemLabel: 'Select',
                      dateRange: true,
                      subItems: [
                          {
                              name: this.$t('By Supervisions'),
                              value: 'by_supervisions',

                          },
                          {
                              name: this.$t('By Recommendations'),
                              value: 'by_recommendations',

                          }
                      ]
                  },
                  {
                      name: this.$t('Equipment Management'),
                      value: 'equipment',
                      subItems: []
                  },
                  {
                      name: this.$t('Workload And Shortage'),
                      value: 'workload',
                      dateRangeMonth: true,
                      subItems: []
                  }
              ]
            },

            dateRangeText: {
                get() {
                    return this.dateRange ? this.dateRange.join(' ~ ') : ''
                },

                set() {
                    this.dateRange = []
                }

            },
            dateRangeTextMonth: {
                get() {
                    return this.dateRangeMonth ? this.dateRangeMonth.join(' ~ ') : ''
                },

                set() {
                    this.dateRangeMonth = []
                }

            },

            countryId() {
                return this.$route.params.countryId
            },

            maxDate() {
                let date = new Date();
                date.setDate(date.getDate() + 1);
                return date.toISOString()
            }
        },

        async mounted() {
            try {
                await this.getCountryById(this.countryId);
                await this.getLaboratoriesByCountry(this.countryId)
            } catch (e) {
                // TODO: handle error router back or 404
                console.error(e)
            }

            window.refs = this.$refs;
        },

        methods: {
            ...mapActions('supervision', {
                supervisionGetByLabs: 'getByLabs',
            }),

            ...mapActions('workload', {
                workloadGetByLabs: 'getByLabs',
            }),

            titleDateFormat(dates) {
                return dates.join(' ~ ')
            },

            onDateRangeChange(e) {
                if (e.length > 1) {
                    this.dateRange = this.dateRange.sort()
                }
            },

            onDateRangeMonthChange(e) {
                if (e.length > 1) {
                    this.dateRangeMonth = this.dateRangeMonth.sort()
                }
            },

            onRequestModule() {
                const MAPPER = {
                    'supervision': this.getSupervision,
                    'equipment': this.getEquipment,
                    'workload': this.getWorkload,
                    'training': this.getTraining,
                };

                this.selectedModuleShow = this.requestModuleSelected;

                MAPPER[this.requestModuleSelected.value]()
            },

            async getSupervision() {
                let ids = this.labsSelected.map(lab => lab.id);
                this.setGlobalLoading(true);
                await this.supervisionGetByLabs(ids).then(res => {
                    this.supervisionData = res.data;
                });
                this.setGlobalLoading(false);

                this.supervisionData.forEach(sup => {
                    sup.laboratory = this.labsSelected.find(lab => lab.id == sup.laboratory)
                })
            },

            getEquipment() {
                this.selectedModuleShow = '';
                this.$nextTick(() => {
                    this.selectedModuleShow = this.requestModuleSelected;
                })
            },

            getTraining() {
                this.selectedModuleShow = '';
                this.$nextTick(() => {
                    this.selectedModuleShow = this.requestModuleSelected;
                })
            },


            async getWorkload() {
                let ids = this.labsSelected.map(lab => lab.id);
                this.setGlobalLoading(true);
                await this.workloadGetByLabs(ids).then(res => {
                    this.workloadData = res.data;
                });

                this.setGlobalLoading(false);

                this.workloadData.forEach(workload => {
                    workload.laboratory = this.labsSelected.find(lab => lab.id == workload.laboratory)
                })
            }
        }
    }
</script>

<style scoped lang="scss">
  ::v-deep .v-date-picker-title__date {
    font-size: 22px;
  }
</style>
